import request from '@/utils/request';

/**
 * 协议配置
 * @returns {{edit: (function(*=): *), getAgreementsList: (function(*): *), getAgreementsInfo: (function(*): *), getAgreementsRecords: (function(*): *)}}
 */
export function agreementsApi () {
    return {
        //协议列表
        getAgreementList: params => {
            return request ({
                url: '/admin/system_config/agreements/list',
                method: 'get',
                params,
            });
        },

        //协议详情
        getAgreementsInfo: params => {
            return request ({
                url: '/admin/system_config/agreements/info',
                method: 'get',
                params,
            });
        },

        //协议编辑
        edit: params => {
            return request ({
                url: '/admin/system_config/agreements/edit',
                method: 'post',
                data: params,
            });
        },

        del: params => {
            return request ({
                url: '/admin/system_config/agreements/del',
                method: 'post',
                data: params,
            });
        },

    };
}
